import Box from '@mui/material/Box';
import type { Theme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';

export const sandboxBannerGlobalStyles = (theme: Theme) => ({
  ':root': {
    '--sandbox-banner-height': '28px',
    [theme.breakpoints.down('md')]: {
      '--sandbox-banner-height': '56px',
    },
  },
  'body': {
    paddingTop: 'var(--sandbox-banner-height)',
  },
});

export const Banner = styled(Box)(({ theme }) => ({
  position: 'fixed',
  left: 0,
  right: 0,
  height: 'var(--sandbox-banner-height)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0, 1),
  textAlign: 'center',
  background: 'lightyellow',
  color: theme.palette.common.black,
  zIndex: theme.zIndex.drawer + 50,
  [theme.breakpoints.down('md')]: {
    fontSize: 12,
    lineHeight: '16px',
  },
}));
